import { Button } from "@material-tailwind/react"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import TopNav from "../../components/topnav/TopNav"
import NotificationsView from "./sections/NotificationsView"


const Notifications = (props) => {
    
    const dispatch = useDispatch()
    const notificaitionsState =  useSelector(state => state.notifications)

    console.log(notificaitionsState)

    // useEffect( 
    //     () => () => dispatch(eventsActions.showCreateNotificationModal(false))
    // , [] );

    return <>
        {/* <TopNav 
            actions={
                <div>
                    <Button  onClick={() => dispatch(eventsActions.showCreateNotificationModal(true))} className="">
                        Create Notifications
                    </Button>
                </div>
            }/> */}
        <div className="w-[75%] m-auto my-20">
            <NotificationsView />
        </div>
        {/* {notificaitonsState.showCreateNotificationModal && <NotificationModal />} */}
    </>
}

export default Notifications